import { Navigate, Route, Routes } from 'react-router-dom';
import { AppProviders } from './AppProviders';
import { MainLayout } from '@/components/layout/MainLayout';
import { DashboardPage } from '@/features/dashboard';
import { GuestDetailsPage } from '@/features/guest-details';

export function App() {
  return (
    <AppProviders>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/guest-details" element={<GuestDetailsPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </AppProviders>
  );
}
